import { MEMBERSHIP_SKUS } from '@/app/[locale]/store/_consts';
import type { RefreshCart_cart_refreshCart_cart_lineItems } from '@/queries/types/RefreshCart';

const getExistingMembership = (
  lineItems: (RefreshCart_cart_refreshCart_cart_lineItems | null)[],
) => {
  return lineItems.find((lineItem) => {
    const sku = lineItem?.skuCode;
    if (!sku) return false;
    return MEMBERSHIP_SKUS.includes(sku);
  });
};

export default getExistingMembership;
